var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState } from 'react';
import dayjs from 'dayjs';
import { DatePickerContent } from './date-picker-content';
import { Tooltip } from '../tooltip/tooltip';
import { TooltipContext } from '../tooltip/tooltip-context';
import { Input } from '../input/input';
export const DatePicker = (_a) => {
    var { onChange } = _a, props = __rest(_a, ["onChange"]);
    const [visible, setVisible] = useState(false);
    const [value, setValue] = useState({ value: dayjs().format('YYYY-MM-DD') });
    const handleChangeDate = useCallback((params) => {
        setValue(params);
        onChange === null || onChange === void 0 ? void 0 : onChange(params);
    }, [onChange]);
    const handleOk = () => {
        var _a;
        setVisible(false);
        (_a = props.onOk) === null || _a === void 0 ? void 0 : _a.call(props, value);
    };
    const handleCancel = () => {
        var _a;
        setVisible(false);
        (_a = props.onCancel) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    const handleTrigger = () => setVisible(true);
    const children = React.Children.map(props.children, (child) => {
        return React.cloneElement(child, Object.assign(Object.assign({}, child.props), { onClick: handleTrigger }), child.props.children);
    });
    return (React.createElement(TooltipContext.Provider, { value: {
            outsideCloseable: true,
        } },
        React.createElement(Tooltip, { trigger: "click", visible: visible, onClickOutside: () => setVisible(false), content: React.createElement(DatePickerContent, { onCancel: handleCancel, onOk: handleOk, value: value === null || value === void 0 ? void 0 : value.value, onChange: handleChangeDate }), placement: "bottom" }, children || (React.createElement(Input, { style: { width: '100px' }, value: dayjs(value === null || value === void 0 ? void 0 : value.value).format('YYYY-MM-DD'), onClick: handleTrigger })))));
};
